Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Cinnamon", {
  enumerable: true,
  get: function get() {
    return _cinnamon.Cinnamon;
  }
});
var _cinnamon = require("./cinnamon");